module.exports = __webpack_public_path__ + "assets/img/fuguoing2.29f63856.png";